(function () {
  'use strict';

  // ── Static Guide Index ─────────────────────────────────────────────────────
  // Sourced from sections/page.liquid (the ebook page guide content).
  // Each entry maps a care guide to its searchable text and ebook page anchor.
  var GUIDES = [
    {
      id: 'guide-aphids',
      title: 'What can I do about Aphids on my Japanese Maple?',
      snippet: 'Aphids are small insects that feed on sap and cause leaf yellowing. Use horticultural oil, insecticidal soaps, or neem oil.',
      keywords: 'aphid aphids insect pest bug sap infestation spray neem oil soap',
    },
    {
      id: 'guide-cold-climates',
      title: 'Growing Japanese Maples in Cold Climates',
      snippet: 'Choose cold-hardy varieties, mulch heavily, use frost cloth, and bring container plants inside during the coldest months.',
      keywords: 'cold winter frost zone hardy climate temperature freeze hardiness usda',
    },
    {
      id: 'guide-common-mistakes',
      title: 'Common mistakes that may kill your Japanese Maple',
      snippet: 'Avoid overwatering, poor drainage, fertilizing at the wrong time, planting too deep, and using plastic for frost protection.',
      keywords: 'mistake kill die dying dead overwater drainage problem issue help trouble wrong',
    },
    {
      id: 'guide-fall-checklist',
      title: 'Fall Gardening Checklist for Japanese Maples',
      snippet: 'Fall is ideal for planting. Do not fertilize in fall, have frost cloth ready, reduce watering, and enjoy the fall color.',
      keywords: 'fall autumn checklist plant seasonal october november dormancy',
    },
    {
      id: 'guide-fertilizing',
      title: 'When do I fertilize my Japanese Maple?',
      snippet: 'Fertilize only in early spring through end of May. Never in fall or winter. Use fertilizer with 15 or lower Nitrogen.',
      keywords: 'fertilize fertilizer fertilizing feed feeding nitrogen nutrient food plant food slow release',
    },
    {
      id: 'guide-frost-damage',
      title: 'What should I do about Frost damage on my Japanese Maple?',
      snippet: 'Do not prune right away. Wait a week, then apply liquid fertilizer and water well to encourage recovery.',
      keywords: 'frost damage frozen freeze cold burn damaged recover recovery dead leaves dieback',
    },
    {
      id: 'guide-frost-protection',
      title: 'How do I protect my Japanese Maple from Frost?',
      snippet: 'Use frost cloth, never plastic. Stake the cloth to prevent branch breakage. Bring container plants inside when possible.',
      keywords: 'frost protect protection cloth cover freeze plastic wrap burlap cold snap blanket sheet',
    },
    {
      id: 'guide-garden-design',
      title: 'Introduction to Garden Design',
      snippet: 'Avoid overcrowding, add conifers for winter interest, mulch for moisture, and ensure well-draining soil before planting.',
      keywords: 'garden design landscape planting layout plan space companion conifer mulch crowding',
    },
    {
      id: 'guide-grafting-tips',
      title: 'What are some tips for Grafting a Japanese Maple?',
      snippet: 'Use healthy rootstock with white roots, sharp clean tools, sterile workspace, and do not overwater after grafting.',
      keywords: 'graft grafting propagate propagation rootstock scion clone cutting',
    },
    {
      id: 'guide-growing-tips',
      title: 'What are some tips for Growing a Japanese Maple?',
      snippet: 'Ensure good drainage, avoid planting too deep, fertilize in spring only, protect from weedeaters and weedkillers.',
      keywords: 'grow growing tips care how to advice beginner start new plant successful success weedeater',
    },
    {
      id: 'guide-hot-climates',
      title: 'Growing Japanese Maples in Hot Climates',
      snippet: 'Protect from afternoon sun (1–3PM). Choose Heatseekers varieties. Mulch roots, and water more frequently in heat.',
      keywords: 'hot heat summer sun afternoon shade climate warm south zone 8 zone 9 heatseekers humid',
    },
    {
      id: 'guide-japanese-beetles',
      title: 'How can I remove Japanese Beetles from my Japanese Maple?',
      snippet: 'Manually remove and dispose of beetles, wash with soapy water to clear pheromones. Use Spectracide for large infestations.',
      keywords: 'beetle japanese beetle bug insect pest infestation pheromone remove spray triazicide',
    },
    {
      id: 'guide-leaf-spots',
      title: 'What is causing spots on the leaves of my Japanese Maple?',
      snippet: 'Main causes are overhead watering in heat, or leaf thrips. Treat with insecticide in early to mid-spring.',
      keywords: 'spot spots leaf spots leaves fungus thrips brown discolor disease blemish mark streak',
    },
    {
      id: 'guide-powdery-mildew',
      title: 'How should I treat Powdery Mildew on my Japanese Maple?',
      snippet: 'Keep area debris-free, ensure proper moisture and sun. Apply fungicide in early spring or late fall as needed.',
      keywords: 'mildew powdery mildew fungus fungal white powder disease treat spray',
    },
    {
      id: 'guide-pruning',
      title: 'How do I prune my Japanese Maple?',
      snippet: 'Prune from early spring through end of May. Remove dead or crossing branches. Never remove more than 25% at once.',
      keywords: 'prune pruning trim trimming cut shape branch canopy deadwood deadhead shear',
    },
    {
      id: 'guide-soil',
      title: 'What type of soil should I use for my Japanese Maple?',
      snippet: 'Use 80% Pinebark, 15% Peat, 5% Perlite. Good drainage is essential. Repot into well-draining mix when needed.',
      keywords: 'soil mix potting pot repot container perlite peat pinebark drainage planting medium bark',
    },
    {
      id: 'guide-spider-mites',
      title: 'How should I treat Spider Mites on my Japanese Maple?',
      snippet: 'Shake leaves over white paper — red dots confirm mites. Spray insecticidal soap on both sides of foliage.',
      keywords: 'spider mite mites web webbing pest bug insect spray soap stippling',
    },
    {
      id: 'guide-spring-checklist',
      title: 'Spring Gardening Checklist for Japanese Maples',
      snippet: 'Protect from late cold snaps, fertilize in early spring, watch for rootstock growth, begin pruning, and check for pests.',
      keywords: 'spring checklist seasonal march april may new growth rootstock',
    },
    {
      id: 'guide-spring-garden',
      title: 'Tips for your Japanese Maple Spring Garden',
      snippet: 'Protect from cold snaps, use frost cloth not plastic, remove rootstock growth promptly, fertilize in spring.',
      keywords: 'spring garden tips seasonal march april may vibrant color',
    },
    {
      id: 'guide-staking',
      title: 'How do I stake my Japanese Maple?',
      snippet: 'Stake in early spring when sap is high and plant is flexible. Use a straight stake and soft ties. Critical for weeping varieties.',
      keywords: 'stake staking support weeping laceleaf upright bamboo tie leaning train',
    },
    {
      id: 'guide-watering',
      title: 'How should I water my Japanese Maple?',
      snippet: 'Water deeply, then let the soil dry out fully before watering again. Overwatering causes root rot — crispy leaves in summer signal too much water.',
      keywords: 'water watering irrigate irrigation drought dry wet root rot overwater crispy leaves brown',
    },
  ];

  // Domain-specific stop words that appear in nearly every guide and add no signal
  var NOISE_RE = /\b(japanese|maple|acer|palmatum|how|what|when|where|why|which|who|do|does|did|i|my|can|should|would|could|is|are|was|were|the|a|an|for|to|of|in|on|at|with|about|from|and|or|if|it|its|that|this|their|them|they|we|you|your|have|has|be|been|will|need|want|get|use|some|any|all|more|most)\b/g;

  function normalizeQuery(raw) {
    return raw
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(NOISE_RE, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function regEsc(s) {
    return s.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  }

  // Pre-build the index once
  var INDEX = GUIDES.map(function (g) {
    var titleNorm = g.title.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
    var keyNorm   = g.keywords.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
    var allNorm   = titleNorm + ' ' + keyNorm;

    return {
      id: g.id,
      title: g.title,
      snippet: g.snippet,
      titleNorm: titleNorm,
      allNorm: allNorm,
      // Ebook page fragment ID (see ebook-page.js makeGuideId)
      ebId: 'eb-guide-' + g.id,
    };
  });

  // ── Scoring ────────────────────────────────────────────────────────────────
  function scoreEntry(entry, words) {
    var score = 0;
    words.forEach(function (word) {
      if (word.length < 3) return;
      var re = new RegExp('\\b' + regEsc(word));
      var rePrefix = word; // substring match

      if (re.test(entry.titleNorm)) {
        score += 8;
      } else if (re.test(entry.allNorm)) {
        score += 4;
      } else if (entry.allNorm.indexOf(rePrefix) !== -1) {
        score += 1.5;
      }
    });
    return score;
  }

  // ── Public API ─────────────────────────────────────────────────────────────
  function search(query, maxResults) {
    if (!query || !query.trim()) return [];

    var normalizedQ = normalizeQuery(query);
    if (!normalizedQ) return [];

    var words = normalizedQ.split(/\s+/).filter(Boolean);
    if (!words.length) return [];

    maxResults = maxResults || 3;

    var scored = [];
    INDEX.forEach(function (entry) {
      var score = scoreEntry(entry, words);
      if (score >= 3) scored.push({ entry: entry, score: score });
    });

    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, maxResults).map(function (item) { return item.entry; });
  }

  function getEbookUrl() {
    return (window.MrMapleConfig && window.MrMapleConfig.ebookUrl) || '/pages/e-book';
  }

  function getGuideUrl(ebId) {
    return getEbookUrl() + '#' + ebId;
  }

  // ── Export ─────────────────────────────────────────────────────────────────
  window.MrMapleEbookSearch = {
    search: search,
    getGuideUrl: getGuideUrl,
    getEbookUrl: getEbookUrl,
  };
})();
